import { AxiosError } from 'axios';
import toast, { Toaster } from 'react-hot-toast';

export const handleError = (error) => {
  if (error?.response?.data?.error.message) {
    toast.error(error?.response?.data?.error.message);
  } else if (error?.response?.data?.error) {
    toast.error(error?.response?.data?.error);
  }else{
    toast.error("Something went wrong");
  }
};
